const config = {
  timeout: 10000,
  withCredentials: true,
  credentials: "same-origin",
};

export default config;
